var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{ref:"route"}),_c('p',{staticClass:"tip"},[_vm._v("以上填写信息将填充至税收居民身份声明文件中，请确保填写内容真实有效")]),_c('div',{staticClass:"button"},[_c('cube-button',{on:{"click":_vm.submit}},[_vm._v("下一步")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }